import React, { Component } from 'react'
import {
  Row,
  Col,
  Button,
  Input,
  Label,
  CustomInput
} from 'reactstrap'
import { MdAdd } from 'react-icons/md'
import Moment from 'moment'
import _ from 'lodash'

import TimeRangePicker from './timeRangePicker'
// import CreateGroup from './createGroup'
import Lang from 'Lang/General'

class OpeningHours extends Component {
  renderClosedDay = () => {
    return(
      <span style={{ color: "#cecece" }}>
        <strong style={{ color: "#b83c3b" }} >{ Lang[ 'CLOSED' ][ this.props.selectedLanguage ] } </strong>
        ( { Lang[ 'ADD_TIME_WINDOW' ][ this.props.selectedLanguage ] } )
      </span>
    )
  }

  sortTimeIntervals = ( openingHourData, dayIndex, intervalId ) => {
    let tmpSelectedGroup = _.cloneDeep( openingHourData )
    tmpSelectedGroup.days.map( day => day.timeIntervals.sort( ( a, b ) => {
      const aMoment = Moment( a.from, [ 'HH:mm', Moment.ISO_8601 ] )
      const bMoment = Moment( b.from, [ 'HH:mm', Moment.ISO_8601 ] )
      if ( !aMoment.isValid() || !bMoment.isValid() ) return 0
      return aMoment.diff( bMoment )
    }))

    if( dayIndex >= 0 && intervalId >= 0 ){
      let removeInterval = false
      let intervalIndex = tmpSelectedGroup.days[ dayIndex ].timeIntervals.findIndex( x => x.id === intervalId )
      let currentInterval = tmpSelectedGroup.days[ dayIndex ].timeIntervals[ intervalIndex ]

      if( !_.isEmpty( tmpSelectedGroup.days[ dayIndex ].timeIntervals[ intervalIndex + 1 ] ) ){
        let laterInterval = tmpSelectedGroup.days[ dayIndex ].timeIntervals[ intervalIndex + 1 ]

        const currentTo = Moment( currentInterval.to, [ 'HH:mm', Moment.ISO_8601 ] )
        const laterFrom = Moment( laterInterval.from, [ 'HH:mm', Moment.ISO_8601 ] )
        if( currentTo.diff( laterFrom ) >= 0 ){
          currentInterval.to = laterFrom.clone().subtract( 1, 'minutes' ).format( 'HH:mm' )

          const currentFrom = Moment( currentInterval.from, [ 'HH:mm', Moment.ISO_8601 ] )
          const newCurrentTo = Moment( currentInterval.to, [ 'HH:mm', Moment.ISO_8601 ] )
          if( currentFrom.diff( newCurrentTo ) >= 0 ){
            removeInterval = true
          }
        }
      }

      if( !_.isEmpty( tmpSelectedGroup.days[ dayIndex ].timeIntervals[ intervalIndex - 1 ] ) ){
        let previousInterval = tmpSelectedGroup.days[ dayIndex ].timeIntervals[ intervalIndex - 1 ]

        const previousTo = Moment( previousInterval.to, [ 'HH:mm', Moment.ISO_8601 ] )
        const currentFrom = Moment( currentInterval.from, [ 'HH:mm', Moment.ISO_8601 ] )
        if( previousTo.diff( currentFrom ) >= 0 ){
          currentInterval.from = previousTo.clone().add( 1, 'minutes' ).format( 'HH:mm' )

          const newCurrentFrom = Moment( currentInterval.from, [ 'HH:mm', Moment.ISO_8601 ] )
          const currentTo = Moment( currentInterval.to, [ 'HH:mm', Moment.ISO_8601 ] )
          if( newCurrentFrom.diff( currentTo ) >= 0 ){
            removeInterval = true
          }
        }
      }

      if( removeInterval ){
        tmpSelectedGroup.days[ dayIndex ].timeIntervals.splice( intervalIndex, 1 )
      }
    }

    if ( _.isEmpty( this.props.selectedOpeningHour.opening_hour ) ) {
      this.props.onChangeLocationsHOC( 'newOpeningHourData', tmpSelectedGroup )
    } else {
      let tmp = {
        ...this.props.selectedOpeningHour,
        opening_hour: tmpSelectedGroup
      }
      this.props.onChangeLocationsHOC( 'selectedOpeningHour', tmp )
    }

    return tmpSelectedGroup
  }

  render = () => {
    return(
      <Col md={ 12 } >
        {
          _.isEmpty( this.props.selectedOpeningHour.opening_hour ) && this.props.newOpeningHourData.days.map( ( day, index ) => <Row style={{
            border: "1px solid #cecece",
            borderLeft: "none",
            borderRight: "none",
            borderTop: index === 0 ? "1px" : "none",
            padding: "10px 0",
            margin: "0",
            alignItems: "center" }} >
            <Col md={ 1 } style={{ paddingLeft: "0" }} >{ Lang[ day.day ][ this.props.selectedLanguage ] }</Col>
            <Col md={ 3 } style={{ paddingLeft: "0" }}>
              <Input
                value={ day.openingDayType }
                type="select"
                onChange={ e => {
                  let tmpSelectedOpeningHour = _.cloneDeep( this.props.newOpeningHourData )
                  let tmpDay = _.cloneDeep( day )
                  tmpDay.openingDayType = e.target.value
                  tmpDay.timeIntervals = []
                  let tmpDayIndex = tmpSelectedOpeningHour.days.findIndex( x => x.day === tmpDay.day )
                  tmpSelectedOpeningHour.days[ tmpDayIndex ] = tmpDay
                  this.props.onChangeLocationsHOC( 'newOpeningHourData', tmpSelectedOpeningHour )
                }}>
                <option value="singleInterval">{ Lang[ 'SINGLE_INTERVAL' ][ this.props.selectedLanguage ] }</option>
                <option value="doubleInterval">{ Lang[ 'DOUBLE_INTERVAL' ][ this.props.selectedLanguage ] }</option>
                <option value="closed">{ Lang[ 'CLOSED' ][ this.props.selectedLanguage ] }</option>
              </Input>
            </Col>
            {
              day.openingDayType !== 'closed' && ( (day.openingDayType === 'singleInterval' && day.timeIntervals.length < 1 ) ||
                (day.openingDayType === 'doubleInterval' && day.timeIntervals.length < 2 ) ) && (
                  <Col md={ 1 } style={{ padding: "0" }} >
                    <Button
                      color='primary'
                      style={{
                        width: "max-content",
                        padding: "5px",
                        border: "1px solid #cecece",
                        borderRadius: "3px",
                        justifyContent: "center"}}
                      onClick={ () => {
                        let tmpGroup = _.cloneDeep( this.props.newOpeningHourData )
                        let tmpDay = _.cloneDeep( day )
                        let tmpInterval = {
                          id: 0,
                          from: day.timeIntervals[0] ? Moment( day.timeIntervals[0].from, [ 'HH:mm', Moment.ISO_8601 ] ).clone().subtract( 2, 'minutes' ).format( 'HH:mm' ) : Moment().format( 'HH:mm' ),
                          to: day.timeIntervals[0] ? Moment( day.timeIntervals[0].from, [ 'HH:mm', Moment.ISO_8601 ] ).clone().subtract( 1, 'minutes' ).format( 'HH:mm' ) : Moment().clone().add( 1, 'hours' ).format( 'HH:mm' )
                        }
                        tmpDay.timeIntervals.unshift( tmpInterval )
                        let tmpDayIndex = tmpGroup.days.findIndex( x => x.day === tmpDay.day )
                        tmpGroup.days[ tmpDayIndex ] = tmpDay
                        tmpGroup.days[ tmpDayIndex ].timeIntervals.map( ( interval, index ) => interval.id = index )
                        this.sortTimeIntervals( tmpGroup )
                      }}>
                      <MdAdd size={ 20 }/>
                    </Button>
                  </Col>
                )
            }
            <Col md={ 7 }>
              <Row>
              {
                day.timeIntervals.length > 0
                ?  day.timeIntervals.map
                (
                  interval => <TimeRangePicker
                    newOpeningHourData={ this.props.newOpeningHourData }
                    day={ day }
                    interval={ interval }
                    from={ interval.from }
                    to={ interval.to }
                    onChangeLocationsHOC={ this.props.onChangeLocationsHOC }
                    sortTimeIntervals={ this.sortTimeIntervals }
                    selectedOpeningHour={ this.props.selectedOpeningHour } />
                )
                : this.renderClosedDay()
              }
              </Row>
            </Col>
          </Row> )
        }
        {
          !_.isEmpty( this.props.selectedOpeningHour.opening_hour ) && this.props.selectedOpeningHour.opening_hour.days.map( ( day, index ) => <Row style={{
            border: "1px solid #cecece",
            borderLeft: "none",
            borderRight: "none",
            borderTop: index === 0 ? "1px" : "none",
            padding: "10px 0",
            margin: "0",
            alignItems: "center" }} >
            <Col md={ 1 } style={{ paddingLeft: "0" }} >{ Lang[ day.day ][ this.props.selectedLanguage ] }</Col>
            <Col md={ 3 } style={{ paddingLeft: "0" }}>
              <Input
                value={ day.openingDayType }
                type="select"
                onChange={ e => {
                  let tmpSelectedOpeningHour = _.cloneDeep( this.props.selectedOpeningHour.opening_hour )
                  let tmpDay = _.cloneDeep( day )
                  tmpDay.openingDayType = e.target.value
                  tmpDay.timeIntervals = []
                  let tmpDayIndex = tmpSelectedOpeningHour.days.findIndex( x => x.day === tmpDay.day )
                  tmpSelectedOpeningHour.days[ tmpDayIndex ] = tmpDay
                  let tmp = {
                      ...this.props.selectedOpeningHour,
                      opening_hour: tmpSelectedOpeningHour
                    }
                  this.props.onChangeLocationsHOC( 'selectedOpeningHour', tmp )
                }}>
                <option value="singleInterval">{ Lang[ 'SINGLE_INTERVAL' ][ this.props.selectedLanguage ] }</option>
                <option value="doubleInterval">{ Lang[ 'DOUBLE_INTERVAL' ][ this.props.selectedLanguage ] }</option>
                <option value="closed">{ Lang[ 'CLOSED' ][ this.props.selectedLanguage ] }</option>
              </Input>
            </Col>
            {
              day.openingDayType !== 'closed' && ( (day.openingDayType === 'singleInterval' && day.timeIntervals.length < 1 ) ||
                (day.openingDayType === 'doubleInterval' && day.timeIntervals.length < 2 ) ) && (
                  <Col md={ 1 } style={{ padding: "0" }} >
                    <Button
                      color='primary'
                      style={{
                        width: "max-content",
                        padding: "5px",
                        border: "1px solid #cecece",
                        borderRadius: "3px",
                        justifyContent: "center"}}
                      onClick={ () => {
                        let tmpGroup = _.cloneDeep( this.props.selectedOpeningHour.opening_hour )
                        let tmpDay = _.cloneDeep( day )
                        let tmpInterval = {
                          id: 0,
                          from: '00:00',
                          to: '00:00'
                        }
                        tmpDay.timeIntervals.unshift( tmpInterval )
                        let tmpDayIndex = tmpGroup.days.findIndex( x => x.day === tmpDay.day )
                        tmpGroup.days[ tmpDayIndex ] = tmpDay
                        tmpGroup.days[ tmpDayIndex ].timeIntervals.map( ( interval, index ) => interval.id = index )
                        this.sortTimeIntervals( tmpGroup )
                      }}>
                      <MdAdd size={ 20 }/>
                    </Button>
                  </Col>
                )
            }
            <Col md={ 7 }>
              <Row>
              {
                day.timeIntervals.length > 0
                ?  day.timeIntervals.map
                (
                  interval => <TimeRangePicker
                    day={ day }
                    interval={ interval }
                    from={ interval.from }
                    to={ interval.to }
                    onChangeLocationsHOC={ this.props.onChangeLocationsHOC }
                    sortTimeIntervals={ this.sortTimeIntervals }
                    selectedOpeningHour={ this.props.selectedOpeningHour } />
                )
                : this.renderClosedDay()
              }
              </Row>
            </Col>
          </Row> )
        }
        {/* <CreateGroup
          newGroup={ this.props.newGroup }
          showCreateGroup={ this.props.showCreateGroup }
          onChangeLocationsHOC={ this.props.onChangeLocationsHOC }/> */}
      </Col>
    )
  }
}

export default OpeningHours